/* eslint-disable react/require-default-props */

import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import { useQuery } from 'react-query';
import Select from 'react-select';
import { getAllRoles } from '../../../services/acl';
import { FieldWrapper } from '../../Form';

const Fields = styled.div`
  display: grid;
  grid-template-columns: minmax(0px, 1fr);
  gap: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
`;

type Props = {
  onSubmit?: SubmitHandler<any>;
  onSelectionChange: any;
};

const filterByRoleName = (candidate: { label: string; value: string; data: any }, input: string) =>
  input ? candidate.data.name.toLowerCase().includes(input.toLowerCase()) : true;

// eslint-disable-next-line
export const AddUserRoleForm = React.forwardRef<HTMLFormElement, Props>(({ onSubmit = () => {}, onSelectionChange = () => {} }, ref) => {
    const { data: allRoles } = useQuery('allRoles', getAllRoles);
    const { control, handleSubmit, watch } = useForm({
      mode: 'onChange',
    });

    const rolesData = watch('roles');

    useEffect(() => {
      if (rolesData) {
        onSelectionChange({ grant: rolesData.grant.name, placeCodes: rolesData.places.map((p) => p.code) });
      }
    }, [rolesData]);

    return (
      <form onSubmit={handleSubmit(onSubmit)} ref={ref}>
        <Fields>
          <FieldWrapper>
            <label htmlFor="roles">Roles </label>
            <Controller
              name="roles"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  placeholder="Search role name"
                  options={allRoles}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => option.name}
                  filterOption={filterByRoleName}
                  isMulti={false}
                  hideSelectedOptions
                  menuPosition="fixed"
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderRadius: '6px',
                      padding: '4px',
                    }),
                    indicatorSeparator: () => ({}),
                  }}
                />
              )}
            />
          </FieldWrapper>
        </Fields>
      </form>
    );
  },
);
